// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__q_N-r","header":"PatientBlock_header__J1sDE","label":"PatientBlock_label__4Wzjc","option":"PatientBlock_option__f-fcy"};